import { ApolloClient, ApolloProvider, InMemoryCache, createHttpLink, from } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { onError } from "@apollo/client/link/error";
import { removeTypenameFromVariables } from "@apollo/client/link/remove-typename";

import { isDev } from "../chillnn/enviroment";

import type { HttpOptions } from "@apollo/client";
import type { ContextSetter } from "@apollo/client/link/context";
import type { ErrorLink } from "@apollo/client/link/error";

type ErrorHandler = ErrorLink.ErrorHandler;

/**
 * 副作用をDIする形でApolloClientを生成する
 * @param getTokenFunction
 * @returns
 */
const clientInitializer = (
	errorHandler: ErrorLink.ErrorHandler,
	httpOptions: HttpOptions,
	contextSetter: ContextSetter,
) => {
	const removeTypenameLink = removeTypenameFromVariables();

	/**
	 * エラーハンドラーをセットする
	 */
	const errorLink = onError(errorHandler);

	/**
	 * エンドポイントをセットする
	 */
	const httpLink = createHttpLink(httpOptions);

	/**
	 * Contextをセットする
	 */
	const contextLink = setContext(contextSetter);

	return new ApolloClient({
		link: from([
			removeTypenameLink, //
			errorLink,
			contextLink.concat(httpLink),
		]),
		cache: new InMemoryCache({
			typePolicies: {
				Query: {
					fields: {
						/**
						 * adultNum ごとに別レスポンス。keyArgs 無しだと Query キャッシュが上書きされる。
						 */
						rateMatrix: {
							keyArgs: ["hotelID", "startDt", "endDt", "adultNum"],
						},
					},
				},
				/**
				 * 行 id は人数に依存しない。正規化すると 2名→1名→2名の切替で guestCells が混ざる。
				 */
				RateMatrix: {
					keyFields: false,
				},
				RateMatrixRow: {
					keyFields: false,
				},
			},
		}),
		connectToDevTools: isDev,
	});
};

export { ApolloProvider, clientInitializer };
export type { ContextSetter, ErrorHandler, HttpOptions };
